<template>
  <div
    class="accordion"
    aria-label="Accordion Group"
  >
    <accordion-item
      v-for="item in items"
      :key="item[identifier]"
      :item-id="item[identifier]"
      :open="expandedItemIds.includes(item[identifier])"
      :animated="animated"
      @accordion-item-selected="toggleOpen"
    >
      <template #item-title>
        <slot
          name="title"
          :is-open="expandedItemIds.includes(item[identifier])"
          :item="item"
        />
      </template>

      <template #item-content>
        <slot
          name="content"
          :item="item"
        />
      </template>
    </accordion-item>
  </div>
</template>



<script>
  export default {
    name: 'Accordion',

    props: {
      animated: {
        type: Boolean,
        default: true
      },
      autoCollapse: {
        type: Boolean,
        default: false
      },
      identifier: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        required: true
      },
      openFirst: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        expandedItemIds: []
      };
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (this.openFirst) {
          this.toggleOpen(this.items[0][this.identifier]);
        }
      },

      toggleOpen(id) {
        if (this.autoCollapse) {
          this.expandedItemIds = this.expandedItemIds[0] === id ? [] : [id];
        }

        else {
          const foundIndex = this.expandedItemIds.indexOf(id);
          const isOpen = foundIndex !== -1;
          this.expandedItemIds = isOpen
            ? this.expandedItemIds.filter(i => i !== id)
            : [...this.expandedItemIds, id];
        }
      }
    }
  };
</script>
